import React from 'react';
export function FeaturedIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.098 21.444a.99.99 0 00.464.115l.002.005a1 1 0 00.986-1.17l-.83-4.832 1.832.74a1 1 0 00.75-1.855l-1.73-.698 3.128-3.05a1 1 0 00-.551-1.707l-4.283-.622 1.064-1.345a1 1 0 10-1.568-1.241L15.12 7.352a.99.99 0 00-.043.06L12.9 3a1.04 1.04 0 00-1.8 0L8.995 7.276a1.008 1.008 0 00-.088-.128L7.648 5.593a1 1 0 10-1.554 1.259l1.215 1.5L2.854 9a1 1 0 00-.554 1.7l3.13 3.047-1.732.7a1 1 0 00.75 1.855l1.83-.74-.828 4.828a1 1 0 001.45 1.054L11 19.29V21a1 1 0 102 0v-1.71l4.098 2.154zm-4.633-4.693a.995.995 0 00-.465-.115.995.995 0 00-.463.119l-3.77 1.98.72-4.2a1 1 0 00-.287-.885l-3.051-2.972 4.213-.613a1 1 0 00.753-.547L12 5.7l1.885 3.814a1 1 0 00.753.547l4.213.613-3.05 2.972a1 1 0 00-.286.885l.719 4.2-3.77-1.98z"
  }));
}